<template>
    <div>
        <h2 class="title">NISCC Report</h2>

       
        <div class="notification is-warning" v-if="loading == true">
            Loading members ...
        </div>
        <div class="notification is-danger" v-if="loading == false && members.length == 0">
            No active members can be found that require NISCC
        </div>

        <table class="table is-fullwidth is-hoverable" v-if="loading == false && this.members.length > 0">
            <thead>
                <tr>
                    <th width="50"></th>
                    <th>Forename</th>
                    <th>Surname</th>
                    <th>Date of Birth</th>
                    <th>NISCC Number</th>
                    <th>NISCC Expiry</th>
                    <th>NISCC Status</th>
                    <th>NMC Status</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="row in this.members" :key="row.id" :class="{'has-background-danger-dark' : row.blocked==1, 'has-text-white' : row.blocked==1}">
                    <td><router-link :to="'/members/' + row.id" target="_blank"><button class="button is-small is-link" >View</button></router-link></td>
                    <td>{{ row.forename }}</td>
                    <td>{{ row.surname}}</td>
                    <td>{{ row.date_of_birth}}</td>
                    <td>{{ row.niscc_number }}</td>
                    <td>{{ row.niscc_expiry }}</td>
                    <td>
                        <span class="tag is-danger" v-if="checkDate(row.niscc_expiry)">Expired</span>
                    </td>
                    <td>
                        <div v-if="row.nmc_expiry != '' && row.nmc_expiry != null">
                        <span class="tag is-success" v-if="checkDate(row.nmc_expiry) == false">Valid</span>
                        <span class="tag is-danger" v-if="checkDate(row.nmc_expiry) == true">Expired</span>
                    </div>
                    </td>
                </tr>
                
                
            </tbody>
            
        </table>

       
    </div>
</template>

<script>
//import MemberService from '@/services/MemberService.js';
import MemberMixin from '@/mixins/MemberMixin.js';

//import MemberGradeTags from '@/components/Generic/MemberGradeTags.vue';

export default {
    
      name: 'NisccReport',
        mixins: [MemberMixin],
        components: {
            //MemberGradeTags
        },
        data: function () {
            return {
                   search: '',
                   members: [],
                   loading: false,
                  
                   showModal: false,
                   order_by: "niscc_expiry ASC"
            }
        },
        methods: {
            checkDate(checkDate) {
                if(checkDate != "" && checkDate != null)
                {
                    const sqlDateParts = checkDate.split('-');
                    
                    const sqlTimestamp = new Date(sqlDateParts[0], sqlDateParts[1] - 1, sqlDateParts[2]);
                    const targetTimestamp = new Date();

                    let isBeforeTargetDate = sqlTimestamp < targetTimestamp;
                    return isBeforeTargetDate
                }
                else{
                    return false
                }
            },
        },
        created() {
            this.getAccessToken()
            .then(() => { 
                this.getNisccMembers(this.order_by)
            });
        
        },
    }
</script>